<template>
    <div class="video-container">
        <div class="oper-group">
            <i v-if="editModeX" class="icon iconfont icon-eye" title="预览视频效果" @click="switchEditMode()"></i>
            <i v-else class="icon iconfont icon-editor" title="设置视频信息" @click="switchEditMode()"></i>
        </div>

        <div class="video-editor" v-if='editModeX' v-bind:style='{width : width + "px", height: height + "px"}'>
            <div class="form-info">
                <div class="form-row video">
                    <div class="form-label">
                        <label><input type="checkbox" v-model="flashFlagX"/><span>Flash格式视频</span></label>
                    </div>
                </div>
                <div class="form-row video">
                    <div class="form-label">
                        <label>视频URL</label>
                    </div>
                    <div class="form-value">
                        <input type="text" v-model="urlX" placeholder="URL"/>
                    </div>
                </div>
                <div class="form-row video">
                    <div class="form-label" style="width: auto">
                        <label>宽<input class="ml5" style="width: 60px;" type="number" v-model="widthX" placeholder="宽"/></label>
                        <span>×</span>
                        <label>高<input class="ml5" style="width: 60px;" type="number" v-model="heightX" placeholder="高"/></label>
                    </div>
                </div>
                <div class="form-row video">
                    <div class="form-label">
                        <label>海报图片</label>
                    </div>
                    <div class="form-value">
                        <input type="text" v-model="posterX" placeholder="URL"/>
                    </div>
                </div>
            </div>
        </div>
        <swb-video-player v-else :flashFlag="flashFlagX" :url="urlX" :width="widthX" :height="heightX" :poster="posterX" :allowFullScreen="allowFullScreenX"></swb-video-player>
    </div>
</template>

<script>
    // last modified by koqiui
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import SwbVideoPlayer from './VideoPlayer.vue';

    Vue.regist(SwbVideoPlayer);

    export default {
        name: 'swb-video-editor',
        desc: '视频信息编辑器',
        props: {
            trackKey: {
                default: null
            },
            flashFlag: {//是否flash
                type: Boolean,
                default: true
            },
            url: {//视频源
                type: String,
                default: null
            },
            width: {
                type: Number,
                default: 480
            },
            height: {
                type: Number,
                default: 300
            },
            poster: {//海报图片
                type: String,
                default: null
            },
            quality: {
                type: String,
                default: 'high'
            },
            allowFullScreen: {//是否允许全屏
                type: Boolean,
                default: true
            }
        },
        //
        data: function () {
            return {
                editModeX: true,
                //
                flashFlagX: true,
                urlX: null,
                widthX: 480,
                heightX: 300,
                posterX: null,
                allowFullScreenX: true
            };
        },
        watch: {
            editMode(newVal, oldVal) {
                this.editModeX = newVal;
            },
            flashFlag(newVal, oldVal) {
                this.flashFlagX = newVal;
            },
            url(newVal, oldVal) {
                this.urlX = newVal;
            },
            width(newVal, oldVal) {
                this.widthX = newVal;
            },
            height(newVal, oldVal) {
                this.heightX = newVal;
            },
            poster(newVal, oldVal) {
                this.posterX = newVal;
            }
        },
        mounted() {
            this.init();
        },
        //
        methods: {
            init() {
                this.flashFlagX = this.flashFlag;
                this.urlX = this.url;
                this.widthX = this.width;
                this.heightX = this.height;
                this.posterX = this.poster;
                this.allowFullScreenX = this.allowFullScreen;
            },
            switchEditMode() {
                this.editModeX = !this.editModeX;
            },
            getResult() {
                return {
                    trackKey: this.trackKey,
                    //
                    flashFlag: this.flashFlagX,
                    url: this.urlX || null,
                    width: Utils.ParseInt(this.widthX),
                    height: Utils.ParseInt(this.heightX),
                    poster: this.posterX || null
                };
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/ctrl/VideoEditor.vue